{
  "header": {
    "title": "Question library",
    "description": "Manage your feedback categories and questions",
    "addCategoryButton": "Add Category"
  },
  "searchInput": {
    "placeholder": "Search questions"
  },
  "delete": {
    "title": "Delete category",
    "description": "Are you sure you want to delete this category? This action cannot be undone, and any associated questions and responses will be permanently removed.",
    "deleteButton": "Delete category",
    "cancelButton": "Cancel"
  },
  "translationOverview": {
    "title": "Translation to other languages",
    "description": "We use AI translation, so the result can have mistakes"
  },
  "detailsPage": {
    "header": {
      "backButton": "Back to Question categories",
      "questionsCount": "{{questionsCount}} questions",
      "addQuestionButton": "Add Question"
    },
    "searchInput": {
      "placeholder": "Search questions"
    },
    "sortDropdown": {
      "triggerLabel": "Sort by",
      "options": {
        "questionQuantity": "Question quantity",
        "fromNewestToOldest": "From newest to oldest",
        "fromOldestToNewest": "From oldest to newest"
      }
    },
    "delete": {
      "title": "Delete question",
      "description": "Are you sure you want to delete this question? This action cannot be undone, and any associated responses will be permanently removed.",
      "deleteButton": "Delete question",
      "cancelButton": "Cancel"
    },
    "translationOverview": {
      "title": "Translation to other languages",
      "description": "We use AI translation, so the result can have mistakes"
    }
  }
}
